export default __webpack_public_path__ + "static/responsive-stack-chart-ab65204d6d3eee794070fad8db39bfff.png";